/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';

export interface NetsNotificationRequest {
    body: string;
    paymentReference?: string;
    refundReference?: string;
    eventType?: string;
    connectCloudRequestId?: string;
}

/**
 * 
 */
export class NetsNotificationControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for netsNotification without sending the request
     */
    async netsNotificationRequestOpts(requestParameters: NetsNotificationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling netsNotification().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['paymentReference'] != null) {
            queryParameters['paymentReference'] = requestParameters['paymentReference'];
        }

        if (requestParameters['refundReference'] != null) {
            queryParameters['refundReference'] = requestParameters['refundReference'];
        }

        if (requestParameters['eventType'] != null) {
            queryParameters['eventType'] = requestParameters['eventType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['connectCloudRequestId'] != null) {
            headerParameters['ConnectCloud-Request-Id'] = String(requestParameters['connectCloudRequestId']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/public-open/psp-notifications/nets/notification`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     */
    async netsNotificationRaw(requestParameters: NetsNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const requestOptions = await this.netsNotificationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async netsNotification(requestParameters: NetsNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.netsNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
